import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  goBackContainerLarge: {
    flex: 0.25,
    alignSelf: 'center',
  },
  goBackContainerSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
    flex: 0.5,
  },
  textTitleLargeCommerce: {
    color: '#807F7F',
  },
  textTitleLargeOrders: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  textLarge: {
    flex: 0.2,
    marginLeft: '0.5%',
    color: '#001639',
    alignSelf: 'center',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25,
  },
  textSmall: {
    flex: 0.55,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25,
  },
  btnContainer: {
    flex: 0.6,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  btnTitle: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 13,
    lineHeight: 10,
  },
  btn: {
    backgroundColor: '#3ABD62',
    borderRadius: 12,
    alignSelf: 'center',
    width: '50%',
  },
  iconLarge: {
    flex: 1,
    alignSelf: 'center',
  },
  iconSmall: {
    flex: 0.15,
    alignSelf: 'center',
  },
  containerIcon: {
    flex: 0.2,
    backgroundColor: '#fff',
    borderRadius: 15,
  },
  openPaymentContainerLarge: {
    flex: 1,
    backgroundColor: '#fff',
    width: '100%',
    position: 'absolute',
    top: '93%',
    paddingBottom: 3,
  },
  openPaymentContainerSmall: {
    flex: 1,
    backgroundColor: '#fff',
    width: '100%',
    position: 'absolute',
    top: '93%',
  },
  paymentSignalContainer: {
    alignSelf: 'center',
    marginBottom: 10,
  },
  productsContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    marginTop: 40,
  },
  headerRow: {
    alignSelf: 'center',
  },
  whatsappIconLarge: {
    fontSize: 8,
    backgroundColor: '#25d366',
    alignSelf: 'flex-start',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 15,
  },
  whatsappIconSmall: {
    fontSize: 8,
    alignSelf: 'flex-end',
    backgroundColor: '#25d366',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 15,
  },
  goToPaymentText: {
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25,
    textAlign: 'center',
  },
});
